module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_spades-queen.cfa694c0.svg";